import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import { Easing } from '@tweenjs/tween.js';
import TransformComponent from '../../../Component/Transform';
import TextComponent from '../../../Component/Render/Text';
import { delay } from '../../../Utility/Task/TaskQueue';

export class StreakTextPopIn extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const textComponent = gameObject.getComponent(TextComponent);
        const transform = gameObject.getComponent(TransformComponent);

        transform.scale.x = 0;
        transform.scale.y = 0;

        const alphaTween = this.getTween(textComponent);
        const scaleTween = this.getTween(transform.scale);
        const moveTween = this.getTween(transform.position);

        yield* delay(100);

        textComponent.alpha = 1;

        scaleTween
            .to({ x: 1, y: 1 }, 400)
            .easing(Easing.Back.Out)
            .start(this.elapsedTime);

        moveTween
            .to({ y: -200 }, 1500)
            .easing(Easing.Quadratic.In)
            .start(this.elapsedTime);

        yield* delay(500);

        alphaTween.to({ alpha: 0 }, 600);

        yield* this.startTween(alphaTween);

        gameObject.destroy();
    }
}
